import { filsToAed } from './engine';
import { currencyMeta, DEFAULT_CURRENCY } from './currency';

// --- Currency-aware money formatters (formatting-only; no FX conversion) ---
export function fmtMoney(fils, currency = DEFAULT_CURRENCY, decimals = 2) {
  const m = currencyMeta(currency);
  return filsToAed(fils).toLocaleString(m.locale, {
    minimumFractionDigits: decimals, maximumFractionDigits: decimals,
  });
}

export function fmtMoneyLabel(fils, currency = DEFAULT_CURRENCY, decimals = 2) {
  const m = currencyMeta(currency);
  return `${m.code} ${fmtMoney(fils, currency, decimals)}`;
}

export function fmtCompactMoney(fils, currency = DEFAULT_CURRENCY) {
  const m = currencyMeta(currency);
  const v = filsToAed(fils);
  const abs = Math.abs(v);
  let s;
  if (abs >= 1e6) s = `${(v / 1e6).toFixed(2)}M`;
  else if (abs >= 1e3) s = `${(v / 1e3).toFixed(1)}K`;
  else s = v.toFixed(0);
  return `${m.code} ${s}`;
}

// --- Legacy AED-defaulted helpers (kept for backward compatibility) ---
export function fmtAED(fils, decimals = 2) {
  return filsToAed(fils).toLocaleString('en-AE', {
    minimumFractionDigits: decimals, maximumFractionDigits: decimals,
  });
}

export function fmtAEDLabel(fils, decimals = 2) {
  return `AED ${fmtAED(fils, decimals)}`;
}

export function fmtCompact(fils) {
  const aed = filsToAed(fils);
  if (Math.abs(aed) >= 1e6) return `${(aed / 1e6).toFixed(2)}M`;
  if (Math.abs(aed) >= 1e3) return `${(aed / 1e3).toFixed(1)}K`;
  return aed.toFixed(0);
}

export function fmtDate(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch { return iso; }
}

export function fmtRelative(iso) {
  if (!iso) return '';
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return fmtDate(iso);
}
